require('./command.js');

(function(){
  PegasusTemplate.CloneColumnCommand = PegasusTemplate.Command.extend({
    klass: null,
    rowKlass: null,
    sourceElement: null,
    callback: null,
    parent: null,
    desiredPosition: null,
    descriptionClass: 'copied',
    description: function(){
      return Em.I18n.t('command_descriptions.cloned_column');
    }.property(),
    execute: function() {
      var parent = PegasusTemplate.blockRegionInstance,
        row = parent.objectAt( this.get('rowPosition') ),
        source = this.get('sourceElement');

      PegasusTemplate.blockRegionInstance.removeObject( row );
      PegasusTemplate.blockRegionInstance.insertAt( this.get('rowPosition'), this.get('rowKlass').create({
        container: parent.container,
        sourceElement: source
      }) );

      this._super();
    },

    unexecute: function(callback){
      var parent = PegasusTemplate.blockRegionInstance,
        reborn = this.get('rowKlass').create({
          container: parent.container,
          sourceElement: this.get('backup')
        });

      parent.removeObject( parent.objectAt( this.get('rowPosition') ) );
      parent.insertAt( this.get('rowPosition'), reborn );

      this._super();
    }
  });
})();

